import { TrophyVariantIcon } from './TrophyVariantIcon';

/**
 * author: Doug C. Hardester
 * id C6664923-EE26-4175-90CB-AD87B517F2FF
 * name trophy-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/trophy-variant.svg
 * tags
 * - Sport 
 */
export const AchievementVariantIcon = TrophyVariantIcon;
export default AchievementVariantIcon